const BASE_COLOR = '#019DFF';

export default {
  languageCustomStyles: {
    option: (provided, state) => ({
      ...provided,
      border: state.isSelected
        ? `1px solid ${BASE_COLOR}`
        : '1px solid transparent',
      display: state.isSelected ? 'none' : 'block',
      borderRadius: '6px',
      background: 'rgba(0,0,0,0.19)',
      textAlign: 'left'
    }),
    control: (provided, state) => ({
      // none of react-select's styles are passed to <Control />
      ...provided,
      background: 'transparent',
      color: '#fff',
      border: 'none',
      minHeight: '36px'
    }),
    menu: (provided, state) => ({
      // none of react-select's styles are passed to <Control />
      ...provided,
      background: 'rgba(0,0,0,0.19)',
      color: '#fff',
      margin: 0
    }),
    menuList: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: '10px'
    }),
    indicatorSeparator: (provided, state) => ({
      display: 'none'
    }),
    container: (provided, state) => ({
      ...provided,
      width: '45vw',
      background: 'rgba(0,0,0,0.19)',
      border: `1px solid ${BASE_COLOR}`,
      borderRadius: '6px',
      marginTop: '3%',
      marginRight: '3%',
      float: 'right'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: '#fff'
    })
  },

  feeSelectorStyles: {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: '10px',
      background: 'rgba(0,0,0,0.19)',
      textAlign: 'left'
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: '0',
      background: 'transparent',
      color: '#fff',
      border: 'none ',
      minHeight: '36px'
    }),
    menu: (provided, state) => ({
      ...provided,
      background: 'rgba(0,0,0,0.7)',
      color: '#fff',
      padding: '10px',
      margin: 0
    }),
    menuList: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: '10px',
      borderRadius: '6px',
      border: `1px solid ${BASE_COLOR}`
    }),
    container: (provided, state) => ({
      ...provided,
      width: '45vw',
      background: 'rgba(0,0,0,0.19*)',
      border: `1px solid ${BASE_COLOR}`,
      borderRadius: '6px',
      marginTop: '3%',
      marginRight: '3%',
      float: 'left'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: '#fff'
    }),
    indicatorSeparator: (provided, state) => ({
      display: 'none'
    })
  },

  gameTypeSelectorStyles: {
    option: (provided, state) => ({
      ...provided,
      background: 'transparent',
      paddingLeft: '10px',
      textAlign: 'left',
      fontWeight: 'bold',
      fontSize: '14px',
      color: 'black'
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: '45px',
      background: 'white',
      boxShadow: '0',
      border: 'none ',
      color: 'black'
    }),
    menu: (provided, state) => ({
      ...provided,
      background: 'white',
      margin: 0,
      top: '0px',
      border: `1.5px solid ${BASE_COLOR}`,
      color: 'black'
    }),
    menuList: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: '10px',
      borderRadius: '0 0 6px 6px'
    }),
    container: (provided, state) => ({
      ...provided,
      width: '45vw',
      float: 'left',
      background: state.isFocused ? 'transparent' : 'white',
      border: '1.5px solid',
      borderColor: state.isFocused ? 'transparent' : BASE_COLOR,
      borderRadius: '6px',
      fontSize: '14px'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: 'black',
      fontWeight: 'bold'
    }),
    indicatorSeparator: (provided, state) => ({
      display: 'none'
    }),
    dropdownIndicator: (provided, state) => ({
      marginRight: '10px',
      color: 'black'
    })
  }
};
